import React from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const AddNewDocumentMenu = ({
  isCreatingName,
  setIsCreatingName,
  newFolderName,
  setNewFolderName,
  isFolderNameError,
  folderNameErrorMessage,
  onFolderCreate,
  onCancelCreatingFolder,
  children,
}) => {
  return (
    <Popover open={isCreatingName}>
      <PopoverTrigger
        className="w-full relative flex select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0 cursor-pointer"
        onClick={() => {
          setIsCreatingName(true);
        }}
      >
        {children}
      </PopoverTrigger>
      <PopoverContent
        align="end"
        alignOffset={-4}
        className="flex flex-col gap-3"
      >
        <p>Opprett mappe:</p>
        <Input
          className="shadow-none"
          type="text"
          label="Opprett mappe:"
          placeholder="Skriv inn mappenavn"
          value={newFolderName}
          onChange={(event) => setNewFolderName(event.target.value)}
        />
        {isFolderNameError && (
          <p className="text-primary text-xs">{folderNameErrorMessage}</p>
        )}
        <div className="flex justify-between">
          <Button
            className="shadow-none"
            type="button"
            variant="outline"
            onClick={onCancelCreatingFolder}
          >
            Avbryt
          </Button>
          <Button
            className="shadow-none"
            type="button"
            variant="default"
            onClick={onFolderCreate}
          >
            Opprett
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default AddNewDocumentMenu;
